<template>
    <v-row class="main-row-fill-height">
        <!-- <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;">
                    <v-toolbar absolute flat color="primary" width="100%" height="70px" dark>
                        <v-toolbar-title>Wertheim Blindstock Multiplex</v-toolbar-title>
                    </v-toolbar>
                    <v-list class="pt-0">
                        <v-list-item-group v-model="active" color="grey darken-4">
                            <v-list-item :style="active === index ? 'pointer-events: none' : ''"
                                v-for="(item, index) in getBlindstockItems" :key="index">
                                <v-list-item-content>
                                    <div class="subtitle-1 d-flex align-center justify-space-between">
                                        {{ item.displayText }}
                                        <v-icon v-if="item.completed()" color="success" class="ml-4">mdi-check-circle
                                        </v-icon>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
            </v-card>
        </v-col> -->
        <v-col cols="9" class="pa-0 pos-rel pad-b">
            <div class="top-bar pl-14 pr-10 py-8" ref="topBar">
                <div class="content">
                    <div class="text-section">
                        <h2 class="mb-2 menu-title">{{$t('blindstockmultiplex')}}</h2>
                        <p class="ma-0 menu-description">{{$t('blindstockmultiplexDescription')}}</p>
                    </div>
                    <!-- <a href="javascript:void(0)" @click="toggleResources = !toggleResources" class="resources-holder" v-if="showResources">
                        <div class="resources" :class="{ 'active': toggleResources }">
                            <div class="resources-placeholders">
                                <p>{{$t('resourcesLabel')}}</p>
                                <p class="font-weight-bold"><span v-if="(typeof bodenniveauunterschiedDocument !== 'undefined')">1 {{$t('documentLabel')}}</span><span v-else>0 {{$t('documentsLabel')}}</span></p>
                            </div>
                            <div class="pl-5 dropdown-icon">
                                <v-icon class="icon-class">mdi-menu-down</v-icon>
                            </div>
                        </div>
                        <transition name="slide-fade">
                            <div class="resources-dropdown" v-if="toggleResources">
                                <div class="resources-placeholders">
                                    <p>{{$t('resourcesLabel')}}</p>
                                    <p class="font-weight-bold"><span v-if="(typeof bodenniveauunterschiedDocument !== 'undefined')">1 {{$t('documentLabel')}}</span><span v-else>0 {{$t('documentsLabel')}}</span></p>
                                </div>
                                <div class="resources-content">
                                    <div v-if="(typeof bodenniveauunterschiedDocument !== 'undefined')" class="d-flex pa-3 mb-4 document-container" >
                                        <v-icon class="mr-2">mdi-file-document-multiple-outline</v-icon>
                                        <a class="black--text" target="_blank" :href="bodenniveauunterschiedDocument.resourceLocation" download>Bodenniveauunterschied Bild</a>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </a> -->
                </div>
            </div>
            <v-divider></v-divider>
            <v-card data-simplebar flat :style="{'height': `calc(100% - ${bodyCalcHeight}px)`, 'max-height' : '100%'}" class="pa-8 pl-12 pt-6">
                <simplebar style="overflow-x: hidden;" class="px-2">
                <template v-if="getSubNavActiveId.mainNavActiveId == 7 && getSubNavActiveId.subNavActiveId == 0">
                    <h3 class="font-weight-regular mb-4 submenu-title">{{$t('wertheimBlindstockMultiplex')}}</h3>
                    <div class="mb-4">
                        <div class="font-weight-bold mb-3 menu-title">{{$t('blindstockSenkrecht')}}</div>
                        <div class="d-flex mb-5">
                            <div class="mr-4" style="width:50%;">
                                <div class="body-2 pb-2" style="">{{$t('hohe')}}</div>
                                <v-text-field  class="unit-text-field" disabled :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BLINDSTOCK_S_HOEHE', context).value.value)" style="" dense outlined hide-details suffix="mm">
                                </v-text-field>
                            </div>
                            <div class="" style="width:50%;">
                                <div class="body-2 pb-2" style="">{{$t('breite')}}</div>
                                <v-text-field  class="unit-text-field" disabled :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BLINDSTOCK_S_BREITE', context).value.value)" style="" dense outlined hide-details suffix="mm">
                                </v-text-field>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="mr-4" style="width:50%;">
                                <div class="body-2 pb-2" style="">{{$t('lange')}}</div>
                                <v-text-field  class="unit-text-field" disabled :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BLINDSTOCK_S_LAENGE', context).value.value)" style="" dense outlined hide-details suffix="mm">
                                </v-text-field>
                            </div>
                            <div style="width:50%;">
                                <div class="body-2 pb-2" style="">{{$t('anzahl')}}</div>
                                <v-text-field  class="unit-text-field" disabled :value="parseToGermanFloat(getRegisteredCharacteristicsValue('CUST_MM_BLINDSTOCK_S_ANZ', context).value.value)" style="" dense outlined hide-details suffix="mm">
                                </v-text-field>
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="font-weight-bold mb-3 menu-title">{{$t('blindstockQuer')}}</div>
                        <div class="d-flex mb-5">
                            <div class="mr-4" style="width:50%;">
                                <div class="body-2 pb-2" style="">{{$t('hohe')}}</div>
                                <v-text-field  class="unit-text-field" disabled :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BLINDSTOCK_W_HOEHE', context).value.value)" style="" dense outlined hide-details suffix="mm">
                                </v-text-field>
                            </div>
                            <div class="" style="width:50%;">
                                <div class="body-2 pb-2" style="">{{$t('breite')}}</div>
                                <v-text-field  class="unit-text-field" disabled :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BLINDSTOCK_W_BREITE', context).value.value)" style="" dense outlined hide-details suffix="mm">
                                </v-text-field>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="mr-4" style="width:50%;">
                                <div class="body-2 pb-2" style="">{{$t('lange')}}</div>
                                <v-text-field  class="unit-text-field" disabled :value="parseToGermanFloat(getRegisteredCharacteristicsValue('KTU_MM_BLINDSTOCK_W_LAENGE', context).value.value)" style="" dense outlined hide-details suffix="mm">
                                </v-text-field>
                            </div>
                            <div style="width:50%;">
                                <div class="body-2 pb-2" style="">{{$t('anzahl')}}</div>
                                <v-text-field  class="unit-text-field" disabled :value="parseToGermanFloat(getRegisteredCharacteristicsValue('CUST_MM_BLINDSTOCK_W_ANZ', context).value.value)" style="" dense outlined hide-details suffix="mm">
                                </v-text-field>
                            </div>
                        </div>
                    </div>
                    <v-checkbox
                        :disabled="blindstockWerthDisabled"
                        v-model="blindstockWerth"
                        :label="$t('wertheimBlindstockMultiplex') + '?'"
                    ></v-checkbox>
                </template>
                <template v-if="getSubNavActiveId.mainNavActiveId == 7 && getSubNavActiveId.subNavActiveId == 1">
                    <v-form ref="blindstockForm" v-model="valid" lazy-validation>
                        <h3 class="font-weight-regular mb-3 submenu-title">{{$t('sonderBlindstock')}}</h3>
                        <v-row>
                            <v-col md="6" sm="12" class="py-0">
                                <div class="subtitle-2 mb-2">{{$t('artDesMaterials')}}</div>

                                <v-select dense outlined return-object :menu-props="{ offsetY: true }" :items="filteredMaterialArts"
                                          item-text="description" :value="mainMaterialArt.value"
                                          @change="setMainMaterialArtValue(getCharacteristicAndValues('CUST_MM_ART_MATERIAL'), $event);">
                                </v-select>
                            </v-col>
                        </v-row>

                        <div class="subtitle-2 mb-2">{{$t('selectBlindstock')}}</div>
                        <v-row>
                            <v-col md="6" sm="12" class="py-0">
                                <v-select dense outlined return-object :menu-props="{ offsetY: true }"
                                          :items="grosseSourceListCharacteristic.values" item-text="description"
                                          :value="blindstockMaterialItem.grosse.value"
                                          @change="addMaterialItemCharacterisitc('grosse', grosseSourceListCharacteristic, $event);">
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <!--                        <v-col cols="6">-->
                            <!--                            <div class="subtitle-2 mb-2">{{$t('beschichtungsseite')}}-->
                            <!--                                &lt;!&ndash; [CUST_MM_BESCHICHTUNGSSEITE] &ndash;&gt;-->
                            <!--                            </div>-->
                            <!--                            <v-select dense outlined hide-details return-object :menu-props="{ offsetY: true }"-->
                            <!--                                :items="getBlindstockMaterialCharacteristicAndValues('CUST_MM_BESCHICHTUNGSSEITE').values"-->
                            <!--                                item-text="description" :value="blindstockMaterialItem.beschichtungsseite.value"-->
                            <!--                                @change="addMaterialItemCharacterisitc('beschichtungsseite', getBlindstockMaterialCharacteristicAndValues('CUST_MM_BESCHICHTUNGSSEITE'), $event)">-->
                            <!--                            </v-select>-->
                            <!--                        </v-col>-->
                            <!--                        <v-col cols="6">-->
                            <!--                            <div class="subtitle-2 mb-2">{{$t('farbe')}}-->
                            <!--                                &lt;!&ndash; [CUST_MM_FARBE] &ndash;&gt;-->
                            <!--                            </div>-->
                            <!--                            <v-select dense outlined hide-details return-object :menu-props="{ offsetY: true }"-->
                            <!--                                :items="getBlindstockMaterialCharacteristicAndValues('CUST_MM_FARBE').values" item-text="description"-->
                            <!--                                :value="blindstockMaterialItem.farbe.value"-->
                            <!--                                @change="addMaterialItemCharacterisitc('farbe', getBlindstockMaterialCharacteristicAndValues('CUST_MM_FARBE'), $event)">-->
                            <!--                            </v-select>-->
                            <!--                        </v-col>-->
                            <!--                        -->
                            <v-col cols="6">
                                <div class="subtitle-2 pb-2" style="">
                                    {{$t('hoheStarke')}}</div>
                                <v-text-field
                                    class="unit-text-field"
                                    v-model="itemHoehe"
                                    :rules="[rules.minValue(parseFloatFromGermanFloat(hoeheValue), $t('requiredValueLabel'))]"
                                    :disabled="isSonderGrosse()" dense outlined
                                    suffix="mm">
                                </v-text-field>
                            </v-col>

                            <v-col cols="6">
                                <div class="subtitle-2 pb-2" style="">
                                    {{$t('breite')}}</div>
                                <v-text-field
                                    class="unit-text-field"
                                    v-model="itemBreite"
                                    :rules="[rules.minValue(parseFloatFromGermanFloat(breiteValue), $t('requiredValueLabel'))]"
                                    :disabled="isSonderGrosse()" dense outlined
                                    suffix="mm">
                                </v-text-field>
                            </v-col>

                            <v-col cols="6">
                                <div class="subtitle-2 pb-2" style="">
                                    {{$t('lange')}}</div>
                                <v-text-field
                                    class="unit-text-field"
                                    v-model="itemLaenge"
                                    :rules="[rules.minValue(parseFloatFromGermanFloat(laengeValue), $t('requiredValueLabel'))]"
                                    dense outlined suffix="mm">
                                </v-text-field>
                            </v-col>

                            <v-col cols="6">
                                <div class="subtitle-2 pb-2" style="">
                                    {{$t('anzahl')}}</div>
                                <v-text-field
                                    class="unit-text-field"
                                    v-model="itemAnzahl"
                                    :rules="[rules.minValue(parseFloatFromGermanFloat(anzahlValue), $t('requiredValueLabel'))]"
                                    dense outlined suffix="Stk.">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <div class="buttons d-flex mx-2 justify-start mb-2">
                            <v-btn min-width="100px" color="primary" @click="addMaterialItem()" class="col-3 mr-4 mt-3">{{$t('addItem')}}</v-btn>
                            <!--                            <v-btn min-width="100px" color="red" @click="clearBlinstockMaterialList()" class="col-6 white&#45;&#45;text">{{$t('clear')}}</v-btn>-->
                        </div>
                    </v-form>

                        <v-data-table dense :headers="tableHeders" :hide-default-footer="true" :items="getBlindstockMaterialsList" disable-pagination :no-data-text="$t('noDataAvailable')" >
                        <template #item.vorhandeneEintrage="{ item }">
                            <div class="text">{{item.materialArt.value.description}}</div>
                        </template>

                        <template #item.grobe="{ item }">
                            <div class="text">{{item.grosse.value.description}}</div>
                        </template>

<!--                         <template #item.beschichtungsseite="{ item }">-->
<!--                            <div class="text">{{item.beschichtungsseite.value.description}}</div>-->
<!--                        </template>-->

<!--                        <template #item.farbe="{ item }">-->
<!--                            <div class="text">{{item.farbe.value.description}}</div>-->
<!--                        </template>-->

                        <template #item.hohe="{ item }">
                            <div class="text">{{item.hoehe.value.value}}</div>
                        </template>

                        <template #item.breite="{ item }">
                            <div class="text">{{item.breite.value.value}}</div>
                        </template>

                        <template #item.lange="{ item }">
                            <div class="text">{{item.laenge.value.value}}</div>
                        </template>

                        <template #item.anzahl="{ item }">
                            <div class="text">{{item.anzahl.value.value}}</div>
                        </template>

                        <template #item.actions="{ item }">
                            <v-btn
                                    class="mx-2"
                                    fab
                                    dark
                                    x-small
                                    color="red"
                                    @click="clearBlinstockMaterialList(item)"
                            >
                                <v-icon dark>
                                    mdi-close
                                </v-icon>
                            </v-btn>
                        </template>
                            <template v-slot:no-data>
                                {{$t('noDataAvailable')}}
                            </template>
                            <template v-slot:no-results>
                                {{$t('noDataAvailable')}}
                            </template>
                    </v-data-table>

                   
                </template>
                </simplebar>
            </v-card>
                <div class="bottom-bar pb-6 text-center">
                    <v-divider class="py-4"></v-divider>
                    <v-btn depressed color="green" dark @click="nextStep();">{{$t('nextStepLabel')}}</v-btn>
                </div>
        </v-col>
        <v-col cols="3" class="py-0">
            <v-card max-height="100%" height="100%" color="grey lighten-3" style="overflow: auto;">
                <v-navigation-drawer width="100%" height="100%" style="padding-top: 70px;" permanent>
                    <div class="d-flex flex-column justify-space-between" style="height: 100%;">
                        <ModelsFound />
                        <div class="pr-1">
                            <v-expansion-panels flat accordion>
                                <RModelSelection />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RFunctions />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RFrame />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RMeasures />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RDoorLeafSurface />
                            </v-expansion-panels>
                            <v-expansion-panels flat accordion>
                                <RExteriorAccessory />
                            </v-expansion-panels>
<!--                            <v-expansion-panels flat accordion>-->
<!--                                <RMountingMaterial></RMountingMaterial>-->
<!--                            </v-expansion-panels>-->
                            <v-expansion-panels flat accordion>
                                <RBlindstockMultiplex />
                            </v-expansion-panels>

                        </div>
                        <div class="d-flex flex-column pa-4 right-buttons-holder">
                            <v-row class="px-2">
                                <v-col cols="6" class="px-2" v-if="newConfiguration">
                                    <v-btn outlined color="primary" width="100%" depressed @click="$EventBus.$emit('cancelDialogConfirmation')">
                                        {{ $t('cancelConfiguration') }}
                                    </v-btn>
                                </v-col>
                                <v-col class="px-2" :class="!newConfiguration? 'col-12' : 'col-6'">
                                    <SaveCurrentConfiguration />
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </v-navigation-drawer>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import {
        mapActions
    } from 'vuex';
    import {
        mapGetters
    } from 'vuex';
    import {
        DoorConfiguration
    } from '../../configurator/DoorConfiguration';
    import {
        MainNavigationFilter
    } from '../../configurator/MainNavigation';
    import {
        Characteristic,
        ValueDefinition,
        MapCharacteristicAndValue
    } from '../../configurator/types';

    import ModelsFound from './components/ModelsFound.vue';
    import RModelSelection from './components/RModelSelection.vue';
    import RFunctions from './components/RFunctions.vue';
    import RFrame from './components/RFrame.vue';
    import RMeasures from './components/RMeasures.vue';
    import RDoorLeafSurface from './components/RDoorLeafSurface.vue';
    import RExteriorAccessory from './components/RExteriorAccessory.vue';
    import RMountingMaterial from './components/RMountingMaterial.vue';

    import RBlindstockMultiplex from './components/RBlindstockMultiplex.vue';

    import SaveCurrentConfiguration from './components/SaveCurrentConfiguration';
    import simplebar from 'simplebar-vue';
    import 'simplebar/dist/simplebar.min.css';
    import * as formula from "../../configurator/CalculatedCharacteristics/BlindstockMultiplexCharacteristics";
    import {parseToGermanFloat, parseFloatFromGermanFloat} from '../../services/ParserService';

    export default Vue.extend({
        name: 'BlindstockMultiplex',
        components: {
            simplebar,
            RModelSelection,
            RFunctions,
            RFrame,
            RMeasures,
            RDoorLeafSurface,
            RExteriorAccessory,
            RMountingMaterial,
            RBlindstockMultiplex,
            ModelsFound,
            SaveCurrentConfiguration
        },
        data() {
            return {
                parseToGermanFloat: parseToGermanFloat,
                parseFloatFromGermanFloat: parseFloatFromGermanFloat,
                valid: true,
                showResources: true,
                toggleResources: false,
                showModal: false,
                showSettingsContent: 1,
                active: 0,
                windowMainNavId: 8,
                blindstockWerthDisabled: false,
                bodenniveauunterschiedDocument: {},
                bodyCalcHeight: 0,
                rules:{
                    minValue(value, message){
                        return (value || "") > 0 || message;
                    }
                },
                tableHeders: 
                    [{
                            text: this.$t('vorhandeneEintrage'),
                            value: 'vorhandeneEintrage'
                        },
                        {
                            text: this.$t('grosse'),
                            value: 'grobe'
                        },
                        // {
                        //     text: 'Beschichtungsseite',
                        //     value: 'beschichtungsseite'
                        // },
                        // {
                        //     text: 'Farbe',
                        //     value : 'farbe'
                        //
                        // },
                        {
                            text: this.$t('hohe') + ' [mm]',
                            value : 'hohe'
                           
                        },
                        {
                            text: this.$t('breite') + ' [mm]',
                            value: 'breite'
                        },
                        {
                            text: this.$t('lange') + ' [mm]',
                            value : 'lange'
                        },
                        {
                            text: this.$t('anzahl') + ' [Stk.]',
                            value : 'anzahl'
                        },
                        {
                            text: '',
                            sortable: false,
                            value: 'actions',
                            align: 'end'
                        },
                    ],
                context: DoorConfiguration.BlindstockMultiplex,
                settignsItems: [],

                uiCharacteristics: [{
                        materialArtValue: 'WINKEL',
                        characteristics: [{
                                item: 'material',
                                code: 'KTU_MM_WINKEL'
                            },
                            {
                                item: 'quantity',
                                code: 'KTU_MM_WINKEL_ANZ'
                            },
                            {
                                item: 'width',
                                code: 'KTU_MM_WINKEL_BREITE'
                            },
                            {
                                item: 'height',
                                code: 'CUST_MM_WINKEL_HOEHE'
                            },
                            {
                                item: 'length',
                                code: 'KTU_MM_WINKEL_LAENGE'
                            },
                            {
                                item: 'surface',
                                code: 'KTU_MM_WINKEL_O'
                            },
                            {
                                item: 'art',
                                code: 'KTU_MM_WINKEL_O_ART'
                            },
                            {
                                item: 'specialSurface',
                                code: 'KTU_MM_WINKEL_O_SO'
                            },
                        ]
                    },
                    {
                        materialArtValue: 'ABDECKLEISTE',
                        characteristics: [{
                                item: 'material',
                                code: 'KTU_MM_ABDECKLEISTE'
                            },
                            {
                                item: 'quantity',
                                code: 'KTU_MM_ABDECKLEISTE_ANZ'
                            },
                            {
                                item: 'width',
                                code: 'KTU_MM_ABDECKLEISTE_BREITE'
                            },
                            {
                                item: 'height',
                                code: 'KTU_MM_ABDECKLEISTE_HOEHE'
                            },
                            {
                                item: 'length',
                                code: 'KTU_MM_ABDECKLEISTE_LAENGE'
                            },
                            {
                                item: 'surface',
                                code: 'KTU_MM_ABDECKLEISTE_O'
                            },
                            {
                                item: 'art',
                                code: 'KTU_MM_ABDECKLEISTE_O_ART'
                            },
                            {
                                item: 'specialSurface',
                                code: 'KTU_MM_ABDECKLEISTE_O_SO'
                            },
                        ]
                    },
                    {
                        materialArtValue: 'BLINDSTOCK',
                        characteristics: [{
                                item: 'material',
                                code: 'KTU_MM_BLINDSTOCK_MM'
                            },
                            {
                                item: 'quantity',
                                code: 'KTU_MM_BLINDSTOCK_ANZ'
                            },
                            {
                                item: 'width',
                                code: 'KTU_MM_BLINDSTOCK_BREITE'
                            },
                            {
                                item: 'height',
                                code: 'KTU_MM_BLINDSTOCK_HOEHE'
                            },
                            {
                                item: 'length',
                                code: 'KTU_MM_BLINDSTOCK_LAENGE'
                            },
                        ]
                    },
                    {
                        materialArtValue: 'AUFDOPPELUNG',
                        characteristics: [{
                                item: 'material',
                                code: 'KTU_MM_MDF'
                            },
                            {
                                item: 'quantity',
                                code: 'KTU_MM_MDF_ANZ'
                            },
                            {
                                item: 'width',
                                code: 'KTU_MM_MDF_BREITE'
                            },
                            {
                                item: 'height',
                                code: 'KTU_MM_MDF_HOEHE'
                            },
                            {
                                item: 'length',
                                code: 'KTU_MM_MDF_LAENGE'
                            },
                        ]
                    }
                ],

                blindstockMaterialItem: {
                    id: '',
                    materialArt: {},
                    grosse: {},
                    // beschichtungsseite: {},
                    // farbe: {},
                    hoehe: {},
                    breite: {},
                    laenge: {},
                    anzahl: {},
                },

                mainMaterialArt: {},

                grosseSourceListCharacteristic: {},

                childCharacteristicsLocal: [],

                mountingMaterialCharacteristicsForSap: [
                    "KTU_MM_ABDECKLEISTE",
                    "KTU_MM_ABDECKLEISTE_ANZ",
                    "KTU_MM_ABDECKLEISTE_BREITE",
                    "KTU_MM_ABDECKLEISTE_HOEHE",
                    "KTU_MM_ABDECKLEISTE_LAENGE",
                    "KTU_MM_ABDECKLEISTE_O",
                    "KTU_MM_ABDECKLEISTE_O_ART",
                    "KTU_MM_ABDECKLEISTE_O_SO",
                    "KTU_MM_BLINDSTOCK_MM",
                    "KTU_MM_BLINDSTOCK_ANZ",
                    "KTU_MM_BLINDSTOCK_BREITE",
                    "KTU_MM_BLINDSTOCK_HOEHE",
                    "KTU_MM_BLINDSTOCK_LAENGE",
                    "KTU_MM_MDF",
                    "KTU_MM_MDF_ANZ",
                    "KTU_MM_MDF_BREITE",
                    "KTU_MM_MDF_HOEHE",
                    "KTU_MM_MDF_LAENGE",
                    "KTU_MM_WINKEL",
                    "KTU_MM_WINKEL_ANZ",
                    "KTU_MM_WINKEL_BREITE",
                    "KTU_MM_WINKEL_LAENGE",
                    "KTU_MM_WINKEL_O",
                    "KTU_MM_WINKEL_O_ART",
                    "KTU_MM_WINKEL_O_SO",
                ],

            }
        },
        computed: {
            ...mapGetters('configuratorModule', ['getSubNavActiveId', 'getCurrentDoorConfiguration', 'getMainNav',
                'getRegisteredCharacteristicsValue', 'getBlindstockItems'
            ]),
            ...mapGetters('blindstockMultiplexModule', [
                'getCharacteristicAndValues', 'getBlindstockMaterialsList', 'getChildCharacteristics',
                'getBlindstockMaterialCharacteristicAndValues', 'getClearedBlindstockByDependency'
            ]),
            ...mapGetters('mountingMaterialModule', ['getMountingMaterialItemsForSap']),

            // temp 
            // ...mapGetters('mountingMaterialModule', ['getStepCharacteristics', 'getCharacteristicAndValues', 'getMountingMaterialsList', 'getChildCharacteristics']),
            newConfiguration: function(){
                if(this.$store.state.configuratorModule.productId == 0){
                    return true
                }
                else{
                    return false
                }
            },
            filteredMaterialArts() {
                const _this = this;
                const mainMaterialArtsList = _this.getBlindstockMaterialCharacteristicAndValues(
                    'CUST_MM_ART_MATERIAL').values.filter((item) => item.value === 'BLINDSTOCK');

                // if(typeof mainMaterialArtsList !== 'undefined' && mainMaterialArtsList.length > 0){
                //     this.initialMaterialItemState();
                // }                

                return mainMaterialArtsList;
            },

            grosseSource() {
                const _this = this;

                this.grosseSourceListCharacteristic = _this.getBlindstockMaterialCharacteristicAndValues(this
                    .mainElementCode);

                return this.grosseSourceListCharacteristic;
            },
            mainElementCode() {

                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'KTU_MM_BLINDSTOCK_MM';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'material')[0].code;
                return code;
            },
            numberOfItemsCode() {

                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'KTU_MM_BLINDSTOCK_ANZ';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'quantity')[0].code;
                return code;
            },
            elementWidthCode() {

                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'KTU_MM_BLINDSTOCK_BREITE';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'width')[0].code;
                return code;
            },
            elementHeightCode() {

                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'KTU_MM_BLINDSTOCK_HOEHE';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'height')[0].code;
                return code;
            },
            elementLengthCode() {

                if (Object.keys(this.mainMaterialArt).length <= 0) {
                    return 'KTU_MM_BLINDSTOCK_LAENGE';
                }

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const code = uiCharacteristic.characteristics.filter(x => x.item === 'length')[0].code;
                return code;
            },
            // elementColorCode() {
            //     const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this.mainMaterialArt.value.value)[0];
            //     const code = uiCharacteristic.characteristics.filter(x => x.item === 'surface')[0].code;
            //     return code;
            // },

            blindstockWerth: {
                get: function() {
                    return this.getRegisteredCharacteristicsValue('CUST_MM_BLINDSTOCK_WERTH', this.context).value.value === 'JA';
                },
                set: function(newVal) {
                    if(newVal){
                        this.checkBoxAddCharacteristic( { characteristicCode : 'CUST_MM_BLINDSTOCK_WERTH', value: 'JA' });
                        this.updateBlindstockMultiplexFormula();
                        this.calculateBlindstockCharacteristic();
                    }
                    else{
                        this.checkBoxAddCharacteristic({ characteristicCode : 'CUST_MM_BLINDSTOCK_WERTH', value: 'NEIN' });
                        this.clearBlindstockMultiplexFormula();
                        this.removeWertheimBlindstock();
                    }
                }
            },
            itemHoehe: {
                get: function () {

                    const _this = this;

                    const propertyValue = parseToGermanFloat(this.getHeightProperty());

                    if (Object.keys(_this.blindstockMaterialItem.hoehe).length > 0) {
                        _this.blindstockMaterialItem.hoehe.value.value = propertyValue;
                        return propertyValue;
                    }

                    return 0;
                },
                set: function (newValue) {
                    this.blindstockMaterialItem.hoehe.value.value = parseFloatFromGermanFloat(newValue);
                }
            },
            itemBreite: {
                get: function () {

                    const _this = this;

                    const propertyValue = parseToGermanFloat(this.getWidthProperty());

                    if (Object.keys(_this.blindstockMaterialItem.breite).length > 0) {
                        _this.blindstockMaterialItem.breite.value.value = propertyValue;
                        return propertyValue;
                    }

                    return 0;
                },
                set: function (newValue) {
                    this.blindstockMaterialItem.breite.value.value = parseFloatFromGermanFloat(newValue);
                }
            },
            itemLaenge: {
                get: function () {
                    const _this = this;
                    return Object.keys(_this.blindstockMaterialItem.laenge).length > 0 ? parseToGermanFloat(_this
                        .blindstockMaterialItem.laenge.value.value) : 0;
                    // return 0;
                },
                set: function (newValue) {
                    const _this = this;
                    _this.blindstockMaterialItem.laenge.value.value = parseFloatFromGermanFloat(newValue);
                }
            },
            itemAnzahl: {
                get: function () {
                    const _this = this;

                    return Object.keys(_this.blindstockMaterialItem.anzahl).length > 0 ? parseToGermanFloat(_this
                        .blindstockMaterialItem.anzahl.value.value) : 0;
                    // return 0;
                },
                set: function (newValue) {
                    const _this = this;
                    _this.blindstockMaterialItem.anzahl.value.value = parseFloatFromGermanFloat(newValue);
                }
            },
            getBlindstock: function() {
                return this.getRegisteredCharacteristicsValue('KTU_MM_BLINDSTOCK', DoorConfiguration.Frame).value.value;
            },
            hoeheValue: {
                get: function(){
                    return Object.keys(this.blindstockMaterialItem.hoehe).length > 0 ? this.blindstockMaterialItem.hoehe.value.value : 0;
                }
            },
            breiteValue: {
                get: function(){
                    return Object.keys(this.blindstockMaterialItem.breite).length > 0 ? this.blindstockMaterialItem.breite.value.value : 0;
                }
            },
            laengeValue: {
                get: function(){
                    return Object.keys(this.blindstockMaterialItem.laenge).length > 0 ? this.blindstockMaterialItem.laenge.value.value : 0;
                }
            },
            anzahlValue: {
                get: function(){
                    return Object.keys(this.blindstockMaterialItem.anzahl).length > 0 ? this.blindstockMaterialItem.anzahl.value.value : 0;
                }
            },
        },
        watch: {
            getBlindstock(getBlindstock) {
                this.setDoorWidthandTopMeasurements();
            },
            // Whenever the mainMaterialArt prop changes, update dependencies
            // mainMaterialArt(mainMaterialArt) {
            //     // console.log('changed mainMaterialArt... ');
            //     this.blindstockMaterialItem.materialArt = mainMaterialArt;
            //     const _this: any = this;

            //     const beschichtungsseiteFilter = {
            //         anchorCharacteristic: this.blindstockMaterialItem.beschichtungsseite, 
            //         dependencieCharacteristic: this.blindstockMaterialItem.materialArt
            //     }
            //     const farbeFilter = {
            //         anchorCharacteristic: this.blindstockMaterialItem.farbe, 
            //         dependencieCharacteristic: this.blindstockMaterialItem.materialArt
            //     }

            //     _this.setCharacteristicDependencies(beschichtungsseiteFilter);
            //     _this.setCharacteristicDependencies(farbeFilter);
            //     // _this.setCharacteristicDependencies(this.blindstockMaterialItem.farbe, this.blindstockMaterialItem.materialArt);
            // },
            grosseSource() {
                // console.log('Groesse source changed...');

                const selectedCharacteristic = MapCharacteristicAndValue(this.grosseSourceListCharacteristic,
                    this.grosseSourceListCharacteristic.values[0]);

                this.blindstockMaterialItem.grosse = selectedCharacteristic;
            },
            // a watcher for getChildCharacteristics computed property, defined in the mountingMaterialStore that returnes childCharacteristics
            getChildCharacteristics(getChildCharacteristics) {

                if (this.childCharacteristicsLocal.length == 0) {

                    this.childCharacteristicsLocal = getChildCharacteristics;
                }
            }
        },
        methods: {
            ...mapActions('configuratorModule', ['updateDoorConfiguration', 'setMainNavigationItems',
                'setMainNavActiveId', 'incrementMainNavActiveId'
            ]),
            ...mapActions('blindstockMultiplexModule', ['setCharacteristicsFromDB', 'checkBoxAddCharacteristic',
                'addBlindstockMaterial', 'clearBlindstockMaterialList', 'setChildCharacteristics',
                'setCharacteristicDependencies', 'setBlindstockMaterialCharacteristics', 'updateBlindstockMultiplexFormula', 'clearBlindstockMultiplexFormula'
                , 'clearBlinstockMaterialList', 'updateClearedBlindstockByDependency', 'calculateBlindstockCharacteristic'
            ]),
            ...mapActions('mountingMaterialModule', ['addMountingMaterialForSap', 'updateBlindstockForSap']),
            ...mapActions('measureModule', ['setDoorWidthandTopMeasurements']),

            // temp
            // ...mapActions('mountingMaterialModule', ['addMountingMaterial', 'clearMountingMaterialList', 'setChildCharacteristics', 'setCharacteristicDependencies']),

            setWertheimBlindstock(event) {
                if(event) {
                    this.updateBlindstockMultiplexFormula();
                }else {
                    this.clearBlindstockMultiplexFormula();
                }
            },
            toggleModal(state) {

                this.showModal = state;
            },
            settingsNavigation(index) {

                this.active = index;

                this.showSettingsContent = index;
            },
            getSettingsItemsFromStore() {
                var setting = this.$store.state.mainMenu.filter((task) => task.id === 8);
                var settingObject = setting[0];

                this.settignsItems = settingObject.characteristicsItems;
                // console.log(this.settignsItems);
            },
            resetModelSelection() {

                this.doorConfiguration = this.getCurrentDoorConfiguration;

                this.doorConfiguration.ClearConfiguration(DoorConfiguration.BlindstockMultiplex);

                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);

                // this.updateNavigation();
                let mainNav = new MainNavigationFilter(this.getMainNav);

                let mainNavItems = mainNav.ResetMainNavigationItemStatus(this.windowMainNavId, false);

                this.setMainNavigationItems(mainNavItems);
            },
            nextStep() {

                let mainNav = new MainNavigationFilter(this.getMainNav);

                let mainNavItems = mainNav.UpdateMainNavigation(this.getNavigationItems, this.windowMainNavId +
                    1);
                // this.$store.dispatch('setMainNavigationItems', mainNavItems);

                this.setMainNavigationItems(mainNavItems);

                const nextMainNavItem = mainNavItems.filter(x => x.itemId == this.windowMainNavId + 1)[0];
                if (nextMainNavItem.disabled == false) {

                    /* this.setMainNavActiveId(this.windowMainNavId + 1); */
					const activeMainNavIndex = this.getMainNav.findIndex(f => f.itemId === this.windowMainNavId)
                    this.incrementMainNavActiveId(activeMainNavIndex);
					this.$EventBus.$emit('triggerMaxHeight')
                    this.$router.push('/product-configurator' + nextMainNavItem.route);
                } else {
                    console.log('Blindstock Multiplex step not completed!');
                }
            },

            displayDescription(fn) {
                try {
                    return fn();
                } catch (e) {
                    return 'Initializing...';
                }
            },
            getWidthProperty() {

                if (this.childCharacteristicsLocal.length === 0 || typeof this.blindstockMaterialItem.grosse
                    .value === 'undefined') {
                    return 0;
                }

                const selectedValue = this.blindstockMaterialItem.grosse.value.value;
                const property = `${selectedValue}_width`;

                const characteristic = this.childCharacteristicsLocal.filter((x) => x.code === property)[0];

                if (typeof characteristic === 'undefined') {
                    return 0;
                }

                const mappedChar = MapCharacteristicAndValue(characteristic, characteristic.values[0]);
                return mappedChar.value.value;
            },
            getHeightProperty() {

                if (this.childCharacteristicsLocal.length === 0 || typeof this.blindstockMaterialItem.grosse
                    .value === 'undefined') {
                    return 0;
                }

                const selectedValue = this.blindstockMaterialItem.grosse.value.value;
                const property = `${selectedValue}_height`;

                const characteristic = this.childCharacteristicsLocal.filter((x) => x.code === property)[0];

                if (typeof characteristic === 'undefined') {
                    return 0;
                }

                const mappedChar = MapCharacteristicAndValue(characteristic, characteristic.values[0]);
                return mappedChar.value.value;
            },
            setMainMaterialArtValue(characteristic, valueDefinition) {
                const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);

                this.mainMaterialArt = selectedCharacteristic;
            },
            addMaterialItemCharacterisitc(materialItem, characteristic, valueDefinition) {
                const _this = this;
                const selectedCharacteristic = MapCharacteristicAndValue(characteristic, valueDefinition);

                this.blindstockMaterialItem[materialItem] = selectedCharacteristic;

                // const configuration = context.rootState.doorConfiguration;
                // configuration.Add(DoorConfiguration.Measure, selectedCharacteristic);                
                // this.addMountingMaterial(selectedCharacteristic);
            },

            addToMatOrCreate(blindstockItem) {
                let isAnyMountingMaterial = this.getMountingMaterialItemsForSap.length;

                if(isAnyMountingMaterial > 0) {
                    let isAnyItemFree = false;
                    let itemFreeIndex = 0;
                    for(let m = 0; m < isAnyMountingMaterial; m++) {
                        let hasBlindstockMM = this.getMountingMaterialItemsForSap[m].find(x => x.code === "KTU_MM_BLINDSTOCK_MM").value;
                        let hasBlindstockANZ = this.getMountingMaterialItemsForSap[m].find(x => x.code === "KTU_MM_BLINDSTOCK_ANZ").value;
                        let hasBlindstockBREITE = this.getMountingMaterialItemsForSap[m].find(x => x.code === "KTU_MM_BLINDSTOCK_BREITE").value;
                        let hasBlindstockHOEHE = this.getMountingMaterialItemsForSap[m].find(x => x.code === "KTU_MM_BLINDSTOCK_HOEHE").value;
                        let hasBlindstockLAENGE = this.getMountingMaterialItemsForSap[m].find(x => x.code === "KTU_MM_BLINDSTOCK_LAENGE").value;

                        if(hasBlindstockMM === "" &&
                            hasBlindstockANZ === "" &&
                            hasBlindstockBREITE === "" &&
                            hasBlindstockHOEHE === "" &&
                            hasBlindstockLAENGE === ""
                        ) {
                            isAnyItemFree = true;
                            itemFreeIndex = m;
                            break;
                        }
                        else {
                            isAnyItemFree = false;
                            itemFreeIndex = 0;
                        }
                    }
                    if(isAnyItemFree === true) {
                        let payloadValue = {
                            index: itemFreeIndex,
                            data: [
                                {
                                    code: "KTU_MM_BLINDSTOCK_MM",
                                    value: blindstockItem.grosse.value.value
                                },
                                {
                                    code: "KTU_MM_BLINDSTOCK_ANZ",
                                    value: blindstockItem.anzahl.value.value
                                },
                                {
                                    code: "KTU_MM_BLINDSTOCK_BREITE",
                                    value: blindstockItem.breite.value.value
                                },
                                {
                                    code: "KTU_MM_BLINDSTOCK_HOEHE",
                                    value: blindstockItem.hoehe.value.value
                                },
                                {
                                    code: "KTU_MM_BLINDSTOCK_LAENGE",
                                    value: blindstockItem.laenge.value.value
                                }
                            ]
                        };
                        this.updateBlindstockForSap(payloadValue);
                    }else {
                        this.addMaterialItemForSap(blindstockItem);
                    }
                }
                else{
                    this.addMaterialItemForSap(blindstockItem);
                }
            },

            addMaterialItem() {
                const valid = this.$refs.blindstockForm.validate();
                if(!valid)
                    return;
                this.blindstockMaterialItem.id = this.uuidv4();
                const mountingMaterialItem1 = JSON.parse(JSON.stringify(this.blindstockMaterialItem));
                this.addBlindstockMaterial(mountingMaterialItem1);
                this.addToMatOrCreate(mountingMaterialItem1);
                // _this.initialMaterialItemState();
            },

            uuidv4() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },

            addMaterialItemForSap(data) {
                let obj = [];

                for (let i = 0; i < this.mountingMaterialCharacteristicsForSap.length; i++) {
                    if(this.mountingMaterialCharacteristicsForSap[i] === data.grosse.code) {
                        obj.push({
                            "code": data.grosse.code,
                            "value": data.grosse.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.hoehe.code) {
                        obj.push({
                            "code": data.hoehe.code,
                            "value": data.hoehe.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.breite.code) {
                        obj.push({
                            "code": data.breite.code,
                            "value": data.breite.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.laenge.code) {
                        obj.push({
                            "code": data.laenge.code,
                            "value": data.laenge.value.value
                        });
                    }
                    else if(this.mountingMaterialCharacteristicsForSap[i] === data.anzahl.code) {
                        obj.push({
                            "code": data.anzahl.code,
                            "value": data.anzahl.value.value
                        });
                    }
                    else {
                        obj.push({
                            "code": this.mountingMaterialCharacteristicsForSap[i],
                            "value": ''
                        });
                    }

                }
                const itemForSap = JSON.parse(JSON.stringify(obj));
                this.addMountingMaterialForSap(itemForSap);
            },
            isSonderGrosse() {
                return this.blindstockMaterialItem.grosse.value.value !== 'LLT800065';
            },
            async filterDependencies(characteristicCode) {
                const _this = this;
                _this.setCharacteristicDependencies();
            },
            removeWertheimBlindstock() {
                let selectWertheimBlindstockValues = this.$store.getters["frameModule/getCharacteristicAndValues"]('KTU_MM_BLINDSTOCK').values;
                let valueToSetDekor = selectWertheimBlindstockValues.find(x => x.value === 'NEIN');
                this.addFrameCharacteristic(this.$store.getters["frameModule/getCharacteristicAndValues"]('KTU_MM_BLINDSTOCK'), valueToSetDekor);
            },

            addFrameCharacteristic(characteristic, valueDefinition) {
                const val = {
                    id: valueDefinition.id,
                    description: valueDefinition.description,
                    value: valueDefinition.value,
                    resource: valueDefinition.resource,
                };

                const selectedCharacteristic = {
                    id: characteristic.id,
                    description: characteristic.description,
                    code: characteristic.code,
                    value: val
                };
                this.doorConfiguration = this.getCurrentDoorConfiguration;
                this.doorConfiguration.Add(DoorConfiguration.Frame, selectedCharacteristic);
                this.$store.dispatch('configuratorModule/updateDoorConfiguration', this.doorConfiguration);
                this.$store.dispatch('frameModule/setConfiguratorCalculatedCharacteristics');
            },
            initialMaterialItemState() {
                const _this = this;
                // _this.blindstockMaterialItem.grosse = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_GROESSE'), _this.getCharacteristicAndValues('CUST_MM_GROESSE').values[0]); 
                // _this.blindstockMaterialItem.beschichtungsseite = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_BESCHICHTUNGSSEITE_WINKEL_MDF'), _this.getCharacteristicAndValues('CUST_MM_BESCHICHTUNGSSEITE_WINKEL_MDF').values[0]); 
                // _this.blindstockMaterialItem.farbe = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_FARBE'), _this.getCharacteristicAndValues('CUST_MM_FARBE').values[0]); 
                // _this.blindstockMaterialItem.hoehe = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_MATERIAL_HOHE_STAERKE'), _this.getCharacteristicAndValues('CUST_MM_MATERIAL_HOHE_STAERKE').values[0]);;
                // _this.blindstockMaterialItem.breite = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_MATERIAL_BREITE'), _this.getCharacteristicAndValues('CUST_MM_MATERIAL_BREITE').values[0]);;
                // _this.blindstockMaterialItem.laenge = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_MATERIAL_LAENGE'), _this.getCharacteristicAndValues('CUST_MM_MATERIAL_LAENGE').values[0]);;
                // _this.blindstockMaterialItem.anzahl = MapCharacteristicAndValue(_this.getCharacteristicAndValues('CUST_MM_MATERIAL_ANZ'), _this.getCharacteristicAndValues('CUST_MM_MATERIAL_ANZ').values[0]);;

                const mainMatArt = _this.getBlindstockMaterialCharacteristicAndValues('CUST_MM_ART_MATERIAL');

                this.mainMaterialArt = MapCharacteristicAndValue(mainMatArt, mainMatArt.values.filter((item) =>
                    item.value === 'BLINDSTOCK')[0]);

                const uiCharacteristic = this.uiCharacteristics.filter(item => item.materialArtValue === this
                    .mainMaterialArt.value.value)[0];

                const mainElementCode = uiCharacteristic.characteristics.filter(x => x.item === 'material')[0]
                    .code;

                const mainElement = _this.getBlindstockMaterialCharacteristicAndValues(mainElementCode);
                // const beschichtungsseite = _this.getBlindstockMaterialCharacteristicAndValues(
                //     'CUST_MM_BESCHICHTUNGSSEITE');
                // const farbe = _this.getBlindstockMaterialCharacteristicAndValues('CUST_MM_FARBE');
                const hoehe = _this.getBlindstockMaterialCharacteristicAndValues(this.elementHeightCode);
                const breite = _this.getBlindstockMaterialCharacteristicAndValues(this.elementWidthCode);
                const laenge = _this.getBlindstockMaterialCharacteristicAndValues(this.elementLengthCode);
                const anzahl = _this.getBlindstockMaterialCharacteristicAndValues(this.numberOfItemsCode);


                _this.blindstockMaterialItem.materialArt = this.mainMaterialArt;
                _this.blindstockMaterialItem.grosse = Object.keys(_this.blindstockMaterialItem.grosse).length <=
                    0 && MapCharacteristicAndValue(mainElement, mainElement.values[0]);
                // _this.blindstockMaterialItem.beschichtungsseite = Object.keys(_this.blindstockMaterialItem
                //     .beschichtungsseite).length <= 0 && MapCharacteristicAndValue(beschichtungsseite,
                //     beschichtungsseite.values[0]);
                // _this.blindstockMaterialItem.farbe = Object.keys(_this.blindstockMaterialItem.farbe).length <=
                //     0 && MapCharacteristicAndValue(farbe, farbe.values[0]);
                _this.blindstockMaterialItem.hoehe = Object.keys(_this.blindstockMaterialItem.hoehe).length <=
                    0 && MapCharacteristicAndValue(hoehe, hoehe.values[0]);
                _this.blindstockMaterialItem.breite = Object.keys(_this.blindstockMaterialItem.breite).length <=
                    0 && MapCharacteristicAndValue(breite, breite.values[0]);
                _this.blindstockMaterialItem.laenge = Object.keys(_this.blindstockMaterialItem.laenge).length <=
                    0 && MapCharacteristicAndValue(laenge, laenge.values[0]);
                _this.blindstockMaterialItem.anzahl = Object.keys(_this.blindstockMaterialItem.anzahl).length <=
                    0 && MapCharacteristicAndValue(anzahl, anzahl.values[0]);

            },
            // async getBlindstockMaterialCharacteristics() {  
            //     const _this: any = this;
            //     NProgress.start();
            //     mountingMaterialService.getMountingMaterialCharacteristics({
            //         progress(e: any) {
            //             if(e.isTrusted) {
            //                 NProgress.done();
            //             }
            //         }
            //     }).then((response: any) => {   

            //         const _this: any = this;               
            //         _this.$store.dispatch('blindstockMultiplexModule/setStepCharacteristics', response.data);
            //     }).then(() => {

            //         this.initialMaterialItemState();
            //     });
            // },
            recalcBodyHeight(){
                //calculation of top-bar height 
                if(this.$refs.topBar.clientHeight != this.bodyCalcHeight)
                    this.bodyCalcHeight = this.$refs.topBar.clientHeight;
            }
        },
        created() {
            window.addEventListener("resize", this.recalcBodyHeight);
        },
        destroyed() {
            window.removeEventListener("resize", this.recalcBodyHeight);
        },
        mounted() {
            const _this = this;

            //calculation of top-bar height 
            this.bodyCalcHeight = this.$refs.topBar.clientHeight;

            NProgress.start();
            this.nextSaveBtnDisabled = true
            _this.setCharacteristicsFromDB().then(() => {
                
                // _this.initialMaterialItemState();
                // console.log('ready for next action...')

                // clear values of Blindstock dependet on dependency chars
                _this.updateClearedBlindstockByDependency();
                // set disabled checkbox
                _this.blindstockWerthDisabled = _this.getClearedBlindstockByDependency;
                //if blindstock is disabled it has to be NEIN end unchecked;
                // if(_this.blindstockWerthDisabled)
                //     _this.blindstockWerth = false;
                _this.blindstockWerth = !_this.blindstockWerthDisabled;

                this.calculateBlindstockCharacteristic();
                NProgress.done();
                this.nextSaveBtnDisabled = false
            });

            _this.setBlindstockMaterialCharacteristics().then((value) => {

                _this.initialMaterialItemState();

                // const beschichtungsseiteFilter = {
                //
                //     anchorCharacteristic: this.blindstockMaterialItem.beschichtungsseite,
                //
                //     dependencieCharacteristic: this.blindstockMaterialItem.materialArt
                // }
                // const farbeFilter = {
                //
                //     anchorCharacteristic: this.blindstockMaterialItem.farbe,
                //
                //     dependencieCharacteristic: this.blindstockMaterialItem.materialArt
                // }

                // _this.setCharacteristicDependencies(beschichtungsseiteFilter);
                // _this.setCharacteristicDependencies(farbeFilter);
            });

            _this.setChildCharacteristics();
            // this.getSettingsItemsFromStore();     
        },
    });
</script>

<style lang="scss" scoped>
    .main-row-fill-height{
        height: 100%;
        margin-left: 0;
        margin-right: 0;
        >.col{
            max-height: 100%;
        }
    }
</style>